export default "__VITE_ASSET__5967b968__"